import { AxiosResponse } from "axios";
import { ISiteAccount } from "~/@core/domain/model/site/SiteAccount";
import { apiSession } from "~/services/api";

export async function getSitesByLoggedUser(): Promise<AxiosResponse<ISiteAccount[]>> {
    return apiSession.get('account/sites');
};  